import { IntervalType as e } from "@ancon/wildcat-types";
function f(n, s = []) {
  if (n === void 0)
    return s.reduce(
      (r, t) => (r.push(
        ...t.intervals.map((o) => ({
          ...o,
          orderFormats: t.orderFormats
        }))
      ), r),
      []
    );
  const u = s.some(
    (r) => r.orderFormats === n
  );
  return s.reduce(
    (r, t) => {
      const o = (t.orderFormats & n) !== n, l = t.intervals.filter(
        (p) => p.type === e.Exception
      ), d = !o && l.length > 0;
      return (!u || !d) && o || (!u || t.orderFormats === n || d) && r.push(
        ...t.intervals.map((p) => ({
          ...p,
          orderFormats: t.orderFormats
        }))
      ), r;
    },
    []
  );
}
export {
  f as default
};
